import { Component, Input, OnInit, Output, EventEmitter, DoCheck } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

@Component({
  selector: 'up-feature-filter-search',
  templateUrl: './feature-filter-search.component.html',
  styleUrls: ['./feature-filter-search.component.scss']
})
export class FeatureFilterSearchComponent implements OnInit, DoCheck {
  filter$: Observable<any>;
  filterSearch: FormGroup;
  searchField: FormControl;

  @Input() filters: Observable<any>;
  @Input() title: any;
  @Input() theme: string;

  @Output() item = new EventEmitter<any>();

  open = false;
  selected = [];
  limit = 50;
  count = 1;
  eventNumber = 1;
  page = 2;
  isSearch = false;

  constructor(public fb: FormBuilder, private store: Store<fromStore.DashboardState>) {}

  ngOnInit(): void {
    this.searchField = new FormControl();
    this.filterSearch = this.fb.group({ search: this.searchField });

    this.searchField.valueChanges.subscribe(res => {
      if (res.length) {
        this.search(res);
      } else {
        this.page = 1;
        this.loadMore();
      }
    });
  }

  ngDoCheck(): void {
    this.filter$ = this.filters;
  }

  onScroll(): void {
    this.loadMore();
  }

  search(q: string): void {
    this.isSearch = true;
    if (this.title === 'Departamentos') {
      this.store.dispatch(fromStore.searchDepartments({ payload: q }));
    }
    if (this.title === 'Cargos') {
      this.store.dispatch(fromStore.searchRoles({ payload: q }));
    }
    if (this.title === 'Filiais') {
      this.store.dispatch(fromStore.searchUnits({ payload: q }));
    }
  }

  loadMore(): void {
    this.isSearch = false;
    if (this.title === 'Departamentos') {
      this.store.dispatch(fromStore.loadMoreDepartments({ payload: { skip: this.calcOffset(this.page), limit: this.limit } }));
    }
    if (this.title === 'Cargos') {
      this.store.dispatch(fromStore.loadMoreRoles({ payload: { skip: this.calcOffset(this.page), limit: this.limit } }));
    }
    if (this.title === 'Filiais') {
      this.store.dispatch(fromStore.loadMoreUnits({ payload: { skip: this.calcOffset(this.page), limit: this.limit } }));
    }
    this.page++;
  }

  calcOffset(count: number): number {
    return (count - 1) * this.limit;
  }

  openFilter(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.open = !this.open;
  }

  trackByIdx(i: number): number {
    return i;
  }

  selectedFilter(el): void {
    if (el.checked) {
      this.selected.push(el.dataset.uid);
    } else {
      const removeUid = this.selected.filter(item => item !== el.dataset.uid);
      this.selected = removeUid;
    }
    this.item.emit(this.selected);
  }
}
